import { PlusIcon } from "app/icons";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { AddOnTableRow } from "../../../types";
import {
  QUOTATION_EQUIPMENT_TABLE_COLUMN_LABELS,
  QUOTATION_FORM_I18N_PREFIX,
} from "../data";
import { useStyles as useAddOnStyles } from "../AddOn/styles";
import { useStyles } from "./styles";

type TableColumn = keyof typeof QUOTATION_EQUIPMENT_TABLE_COLUMN_LABELS;

type Props = {
  titleKey: string;
  columns: TableColumn[];
  rows: AddOnTableRow[];
  variant: "toolbox" | "openBasket";
  onAddRow: () => void;
};

const resolveValue = (value: string, t: (key: string) => string) =>
  value.startsWith("WORK_ORDER.") ? t(value) : value;

const QuotationEquipmentTable = ({ titleKey, columns, rows, variant, onAddRow }: Props) => {
  const { t } = useTranslation();
  const addOnStyles = useAddOnStyles();
  const styles = useStyles();
  const headClass = variant === "toolbox" ? addOnStyles.tableHeadRow : styles.equipmentOpenBasketHead;
  const bodyClass = variant === "toolbox" ? addOnStyles.tableBodyRow : styles.equipmentOpenBasketBody;

  return (
    <Box className={addOnStyles.tableBlock}>
      <Box className={addOnStyles.tableHeaderRow}>
        <Typography className={addOnStyles.tableTitle}>{t(titleKey)}</Typography>
        <Button
          className={addOnStyles.addRowButton}
          variant="contained"
          color="primary"
          startIcon={<PlusIcon width={20} height={20} />}
          onClick={onAddRow}
        >
          {t(`${QUOTATION_FORM_I18N_PREFIX}.TYING_EQUIPMENT.TABLES.ADD_ROW`)}
        </Button>
      </Box>
      <Box className={addOnStyles.table}>
        <Box className={headClass}>
          <Typography className={addOnStyles.tableHeadCell}>#</Typography>
          {columns.map((column) => (
            <Typography key={column} className={addOnStyles.tableHeadCell}>
              {t(QUOTATION_EQUIPMENT_TABLE_COLUMN_LABELS[column])}
            </Typography>
          ))}
        </Box>
        {rows.map((row, index) => (
          <Box key={row.id} className={bodyClass}>
            <Box className={`${addOnStyles.tableCell} ${addOnStyles.tableIndexCell}`}>{index + 1}</Box>
            {columns.map((column) => (
              <Box key={`${row.id}-${column}`} className={addOnStyles.tableCell}>
                <Typography className={addOnStyles.tableCellText}>
                  {resolveValue(row[column], t)}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default QuotationEquipmentTable;
